module.exports = __webpack_public_path__ + "static/media/work (7).39aeb34d.jpg";